import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Heuristic } from '../../jscaip/AI/Heuristic';
import { TrexoRules } from './TrexoRules';
export class TrexoAlignmentHeuristic extends Heuristic {
    getBoardValue(node, _config) {
        let score = 0;
        const state = node.gameState;
        for (const coordAndContent of state.getCoordsAndContents()) {
            // for every column, starting from the bottom of each column
            // while we haven't reached the top or an empty space
            const pieceOwner = coordAndContent.content.getOwner();
            if (pieceOwner.isPlayer()) {
                const squareScore = TrexoRules.getSquareScore(state, coordAndContent.coord);
                score += squareScore;
            }
        }
        return BoardValue.of(score);
    }
}
